<div class="mb-4">
  <div class="wizard-steps-wrapper">
    <div class="wizard-steps">
      @for (step of steps; track step.number) {
        <div
          class="wizard-step"
          [attr.data-alert]="step.completed ? 'success' : 'info'"
          [attr.step-num]="step.number"
          [ngClass]="{ active: step.active, completed: step.completed }"
          [class.clickable]="!step.disabled"
          role="button"
          tabindex="0"
          (click)="handleClickStep(step)"
          (keyup.enter)="handleClickStep(step)"
        >
          <div class="step-circle">
            @if (step.completed) {
              <i class="fas fa-check"></i>
            } @else {
              {{ step.number }}
            }
          </div>
          <div class="step-label">{{ step.title }}</div>
        </div>
        @if (step.number < steps.length) {
          <div
            class="step-connector"
            [class.completed]="step.completed"
          ></div>
        }
      }
    </div>
  </div>
</div>
